export const convertDateToInputFormat = (dateStr) => {
  if (!dateStr) {
    return "";
  }

  const match = String(dateStr).match(
    /(\d{1,2})\/(\d{1,2})\/(\d{2,5})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?/
  );
  if (!match) {
    return "";
  }

  let year = match[3];
  if (year.length === 2) {
    year = `20${year}`;
  }
  if (year.length === 5 && year.startsWith("20")) {
    year = `20${year.slice(-2)}`;
  }

  const yearNum = Number(year);
  if (!Number.isFinite(yearNum) || yearNum < 2000 || yearNum > 2100) {
    return "";
  }

  const month = match[2].padStart(2, "0");
  const day = match[1].padStart(2, "0");
  const hour = match[4].padStart(2, "0");
  const minute = match[5].padStart(2, "0");
  return `${yearNum}-${month}-${day}T${hour}:${minute}`;
};

export const normalizeDateTimeLocal = (datetimeLocalString) => {
  if (!datetimeLocalString || typeof datetimeLocalString !== "string") {
    return "";
  }

  const match = datetimeLocalString.match(
    /^(\d{4,5})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/
  );
  if (!match) {
    return "";
  }

  let year = match[1];
  if (year.length === 5 && year.startsWith("20")) {
    year = `20${year.slice(-2)}`;
  }

  const yearNum = Number(year);
  if (!Number.isFinite(yearNum) || yearNum < 2000 || yearNum > 2100) {
    return "";
  }

  return `${yearNum}-${match[2]}-${match[3]}T${match[4]}:${match[5]}`;
};

export const formatToISOString = (datetimeLocalString) => {
  const normalized = normalizeDateTimeLocal(datetimeLocalString);
  if (!normalized) {
    return "";
  }
  return `${normalized}:00`;
};

export const SERVICE_ORDER_SORTABLE_COLUMNS = [
  { field: "dateRequest", label: "Criação", defaultDirection: "desc" },
  { field: "orderNumber", label: "Número OS", defaultDirection: "desc" },
  { field: "requesterName", label: "Solicitante", defaultDirection: "asc" },
  { field: "summary", label: "Serviço", defaultDirection: "asc" },
  { field: "dateExpected", label: "Agendamento", defaultDirection: "asc" },
  { field: "priorityId", label: "Prioridade", defaultDirection: "desc" },
  { field: "situationId", label: "Situação", defaultDirection: "asc" },
  { field: "unityName", label: "Unidade", defaultDirection: "asc" },
];

export const parseSortValue = (sortBy) => {
  const [field, direction = "desc"] = String(sortBy || "").split(",");
  return {
    field,
    direction: direction === "asc" ? "asc" : "desc",
  };
};

export const buildSortValue = (field, direction) => `${field},${direction}`;

export const getNextSortValue = (currentSort, field, defaultDirection = "asc") => {
  const { field: currentField, direction } = parseSortValue(currentSort);

  if (currentField === field) {
    return buildSortValue(field, direction === "asc" ? "desc" : "asc");
  }

  return buildSortValue(field, defaultDirection);
};

export const SERVICE_ORDER_SORT_OPTIONS = SERVICE_ORDER_SORTABLE_COLUMNS.flatMap(
  ({ field, label, defaultDirection }) => [
    {
      value: buildSortValue(field, defaultDirection),
      label: `${label} (${defaultDirection === "asc" ? "crescente" : "decrescente"})`,
    },
    {
      value: buildSortValue(
        field,
        defaultDirection === "asc" ? "desc" : "asc"
      ),
      label: `${label} (${defaultDirection === "asc" ? "decrescente" : "crescente"})`,
    },
  ]
);

export const buildServiceOrderFilterParams = (
  filters,
  page,
  size,
  sort = "dateRequest,desc"
) => {
  const apiParams = {
    page,
    size,
    sort,
  };

  if (filters.os) {
    apiParams.orderNumber = filters.os;
    return apiParams;
  }

  if (filters.startDate) {
    apiParams.dateRequestMin = filters.startDate;
  }
  if (filters.endDate) {
    apiParams.dateRequestMax = filters.endDate;
  }
  if (filters.priority) {
    apiParams.priority = filters.priority;
  }
  if (filters.status) {
    apiParams.situation = filters.status;
  }

  return apiParams;
};
